import { AtpAgent } from '@atproto/api';
import { createContext } from 'react';

/**
 * A *logged in* atproto agent. The type is narrowed to reflect the logged in
 * status.
 */
export type Agent = AtpAgent & {
  did: NonNullable<AtpAgent['did']>;
};

/** A shared context to store the agent. */
export const AgentCtx = createContext<Agent | undefined>(undefined);
